interface IconProps {
  className?: string;
}

export function StudyIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      {/* Graduation cap */}
      <path
        d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
        fill="currentColor"
        stroke="none"
      />
      <path
        d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"
        fill="currentColor"
        stroke="none"
        opacity="0.6"
      />
    </svg>
  );
}
